import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './presentation/containers/app';
import { Provider } from 'react-redux';
import { store } from './application/store/index';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './application/configurations/authConfig';
import envConfig from './application/configurations/envConfig';
import { appConstants } from './application/configurations/constants';

/**
 * Main component with providers.
 *
 * @component
 */

const msalInstance = new PublicClientApplication(msalConfig);
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Get the URL of the previous page the user visited
const previousUrl: string = document.referrer;
let url = '';

// If there is a previous URL, process it to remove 'https://' and the leading '/'
if (previousUrl) {
    url = previousUrl.replace('https://', '').replace('/', '');
}

// Storing context in local storage from the root component is necessary.
// This is because when the token expires, it redirects to the auth page to get a refresh token.
// At this time, storing context is necessary to display the header and footer based on this context.
if (Array.isArray(envConfig.intranetHostName) && envConfig.intranetHostName.includes(url)) {
    // Retrieve the current context from local storage
    let context = localStorage.getItem('context');

    // Check if the context is not already set to 'intranet' before updating it
    if (context !== appConstants.intranet) {
        localStorage.setItem('context', appConstants.intranet);
    }
}

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </Provider>
  </React.StrictMode>
);
